import { useTranslation } from 'react-i18next';

import {
  ZfDialog,
  ZfDialogContent,
  ZfDialogFooter,
  ZfDialogHeader,
  ZfLoadingSpinner,
  ZfStack,
  ZfTextButton,
  ZfTypography,
} from '@zafire/react';

interface DeleteDialogProps {
  show: boolean;
  loading: boolean;
  onClose: () => void;
  onProceed: () => void;
}
export const DeleteNoteDialog = ({ show, onClose, onProceed, loading }: DeleteDialogProps) => {
  const { t } = useTranslation();
  return (
    <>
      <ZfDialog size="small" show={show} onDialogClose={() => onClose()}>
        <ZfDialogHeader> {t('contactNote.deleteForm.title')}</ZfDialogHeader>
        <ZfDialogContent>
          <ZfTypography style={{ whiteSpace: 'pre-line' }}>{t('contactNote.deleteForm.content')}</ZfTypography>
        </ZfDialogContent>
        <ZfDialogFooter>
          <ZfStack slot="primary" direction="row" spacing="small">
            <ZfTextButton size="medium" hierarchy="tertiary" onClick={() => onClose()}>
              {t('contactNote.deleteForm.cancel')}
            </ZfTextButton>
            <ZfTextButton
              size="medium"
              kind="destructive"
              onClick={() => {
                !loading && onProceed();
              }}
            >
              {loading && <ZfLoadingSpinner color="light" size="small" />}
              {t('contactNote.deleteForm.proceed')}
            </ZfTextButton>
          </ZfStack>
        </ZfDialogFooter>
      </ZfDialog>
    </>
  );
};
